import Axios from "../../api/Axios";
const BASE_URL = "OddLotConversion/";
const Default_BASE_URL = "Default/";

export const EndpointOddLotConversion = {
    GetAllOddLotData: "GetAllOddLotData",
    PopulateWarehouseData: "PopulateWarehouseData",
    GetProductListOddLot: "GetProductListOddLot",
    GetPackfactor: "GetPackfactor",
    GetYREndTag: "GetYREndTag",
    GetProdTransDate: "GetProdTransDate",
    SaveOddLotData: "SaveOddLotData",
    WhDefaultVal : "WhDefaultVal"
};

export const createAPIEndpointOddLotConversion = () => {
    return { 
        getDefaultValue:(Endpoint)=>Axios.get(Default_BASE_URL+Endpoint),
        get: (Endpoint) => Axios.get(BASE_URL + Endpoint),
        post: (Endpoint, data) => Axios.post(BASE_URL + Endpoint, data),
    };

};
